import styled, { css } from 'styled-components'

import mediaQueries from 'components/media-queries'
import { modal as e2eClasses, common as commonE2eClasses } from 'constants/e2eClasses'

export const CloseModalWrapper = styled.div.attrs(() => ({
  className: e2eClasses.box
}))`
  ${({ noImage }) => (noImage ? 'padding: 40px 0' : 'padding: 20px')};
  position: relative;

  ${mediaQueries.mobile`
    ${({ fullHeight }) => fullHeight && `height: calc(100vh - 84px);`};
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    padding: 20px;
  `}
`

export const IconWrapper = styled.button.attrs(() => ({
  className: e2eClasses.close
}))`
  position: absolute;
  cursor: pointer;
  ${({ noImage }) => (noImage ? 'top: 40px;' : 'top: 25px;')};
  right: 30px;
  ${mediaQueries.mobile`
    top: 25px;
  `}
`

export const Title = styled.h2.attrs(() => ({
  className: e2eClasses.title
}))`
  font-family: ${({ theme }) => theme.fonts.semiBold};
  color: ${({ theme }) => theme.colors.blue};
  ${({ paddingRight }) => paddingRight && 'padding-right: 40px;'};
  font-size: 24px;
`

export const SublineWrapper = styled.div`
  margin: 30px 0 40px;
`

export const Subline = styled.p.attrs(() => ({
  className: e2eClasses.text
}))`
  font-family: ${({ theme }) => theme.fonts.regular};
  color: ${({ theme }) => theme.colors.darkGrey};

  font-size: 14px;
  ${({ textJustify }) => textJustify && 'text-align: justify;'};
`

export const ButtonsWrapper = styled.div`
  display: grid;
  grid-template-columns: ${({ withCancel }) => (withCancel ? '1fr 1fr' : '1fr')};
  grid-gap: 30px;

  ${mediaQueries.mobile`
    grid-template-columns: 1fr;
    grid-gap: 10px;
  `}
`
export const ButtonLoader = styled.div`
  border: 5px solid rgba(255, 255, 255, 0.3);
  border-radius: 50%;
  border-top: ${({ theme }) => `4px solid ${theme.colors.blue}`};
  width: 20px;
  height: 20px;
  position: absolute;
  left: 50%;
  margin-left: -10px;
  animation: spin 1s linear infinite;

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`

export const Button = styled.button.attrs(props => ({
  className: props.e2eClass && `${commonE2eClasses.button}${props.e2eClass}`
}))`
  background: ${({ confirm, theme, disabled }) =>
    disabled ? theme.colors.grayLight : confirm ? theme.colors.blue : theme.colors.gray};
  font-family: ${({ theme }) => theme.fonts.semiBold};
  color: ${({ theme }) => theme.colors.white};
  height: 40px;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  transition: background-color 0.3s;

  width: ${({ buttonWidth }) => buttonWidth || 'auto'};
  ${({ buttonWidth }) =>
    buttonWidth &&
    css`
      justify-self: center;
    `};

  border: none;
  border-radius: 3px;
  padding: 10px 50px;
  font-size: 16px;
  cursor: pointer;
`

export const ImageWrapper = styled.div`
  display: flex;
  justify-content: center;
`

export const Image = styled.img`
  margin: 24px 0 16px;

  ${mediaQueries.mobile`
    width: 100px;
  `}
`

export const SubTitle = styled.div`
  font-size: 20px;
  font-family: ${({ theme }) => theme.fonts.semiBold};
  color: ${({ theme }) => theme.colors.blue};
  text-align: center;

  ${mediaQueries.mobile`
    margin-bottom: 8px;
  `}
`

export const ModalLabel = styled.span`
  font-family: ${({ theme }) => theme.fonts.regular};
  color: ${({ theme }) => theme.colors.doveGray};
  font-size: 16px;
  text-align: center;
  margin-bottom: 32px;
`

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 50px;
  ${mediaQueries.mobile`
    padding: 0;
  `}
`
